export enum EditMode {
  CREATE = "CREATE",
  EDIT = "EDIT"
}
